<template>
  <div class="gt-table">
    <!-- hidden-columns -->
    <div class="hidden-columns" ref="hiddenColumns"><slot></slot></div>

    <!-- header -->
    <div class="gt-table__header-wrapper">
      <table-header :store="store" />
    </div>

    <!-- el-body -->
    <div class="gt-table__body-wrapper">
      <table-body :store="store" />

      <div
        v-if="!data || data.length === 0"
        class="gt-table__empty-block"
        ref="emptyBlock"
      >
        <img
          class="gt-table__empty-icon"
          src="./empty-placeholder.png"
          alt="empty-table"
        />
        <span class="gt-table__empty-text">No Data</span>
      </div>
    </div>
  </div>
</template>

<script>
import { createStore } from "element-ui/packages/table/src/store/helper";
import tableHeader from "./header.vue";
import tableBody from "./body.vue";
import fixed from "./fixed.js";

// TODO
// rowHeaderVisibleCondition rowFooterVisibleCondition 的变化没有监听

// column 里面prop的变化没有监听
export default {
  name: "GtTable",

  components: {
    tableHeader,
    tableBody
  },

  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },

    rowHeaderVisibleCondition: {
      type: [Function, Boolean],
      default() {
        return true;
      }
    },

    rowFooterVisibleCondition: {
      type: [Function, Boolean],
      default() {
        return true;
      }
    },

    // 固定表头
    headerFixed: {
      type: Boolean,
      default: false
    },

    // 固定表头用，获取滚动元素的函数
    getContainer: {
      type: [Function]
    }
  },

  data() {
    this.store = createStore(this, {
      selectOnIndeterminate: true
    });

    this.isTable = true;

    return {};
  },

  watch: {
    data: {
      immediate: true,
      handler(value) {
        this.store.commit("setData", value);
      }
    }
  },

  methods: {
    // [unusefull] 需要实现该方法, 但是不需要有逻辑
    debouncedUpdateLayout() {}
  },

  mounted() {
    this.store.updateColumns();

    // 固定表头
    if (this.headerFixed) {
      this.$nextTick(() => {
        this.fixed = new fixed({
          getContainer: this.getContainer,

          el: this.$el
        });
      });
    }

    this.$ready = true;
  },

  beforeDestroy() {
    this.fixed && this.fixed.destroy();
  }
};
</script>

<style lang="scss">
// table
.gt-table {
  &__header-wrapper,
  &__body-wrapper {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    position: relative;
  }

  &__header-wrapper {
    background: #f7f9fa;
  }

  &__body-wrapper {
    padding-top: 16px;
    padding-bottom: 16px;
    background: #ffffff;
  }

  .is-center {
    text-align: center;
  }

  .is-right {
    text-align: right;
  }
}

[class*=" gt-table__column-"],
[class^="gt-table__column-"] {
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
  display: flex;
  align-items: center;

  .cell {
    padding-left: 16px;
    padding-right: 16px;
    // flex: 1;
    width: 100%;
  }
}
</style>

<style lang="scss">
// header
.gt-table__header {
  display: flex;

  &-column {
    overflow: hidden;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    user-select: none;
    line-height: 20px;
    font-size: 14px;
    padding-top: 12px;
    padding-bottom: 12px;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.gt-table__row {
  + .gt-table__row {
    margin-top: 16px;
  }

  &-header {
    padding: 12px 24px;
    background: #fafbfc;
    border-top: 1px solid #e8ebf0;
    border-right: 1px solid #e8ebf0;
    border-left: 1px solid #e8ebf0;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }

  &-body {
    display: flex;
  }

  &-column {
    padding-top: 16px;
    padding-bottom: 16px;
    border-top: 1px solid #e8ebf0;
    border-right: 1px solid #e8ebf0;
    border-bottom: 1px solid #e8ebf0;
    overflow: hidden;

    &.is-first {
      border-left: 1px solid #e8ebf0;
    }

    .cell {
      line-height: 20px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  &-footer {
    padding: 12px 24px;
    background: rgba(230, 244, 255, 0.5);
    border-bottom: 1px solid #e8ebf0;
    border-right: 1px solid #e8ebf0;
    border-left: 1px solid #e8ebf0;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>

<style lang="scss">
.gt-table__empty-icon {
  width: 180px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.gt-table__empty-text {
  width: 50%;
  display: block;
  margin: 0 auto;
  line-height: 60px;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
}
</style>
